import React from 'react'
import { components, MultiValueGenericProps } from 'react-select'
import Tippy from '@tippyjs/react'
import { ColorOption, colorOptions, HandleSetSentiment, TooltipSelectOption } from '../tooltip-select.model'

const Tooltip = (options: TooltipSelectOption[], handleSetSentiment: HandleSetSentiment) => {
	const MultiValueContainer = (props: MultiValueGenericProps<TooltipSelectOption>) => {
		if (props.data.sentimentEnabled === false) {
			return (
				<div>
					<components.MultiValueContainer {...props} />
				</div>
			)
		}

		const { sentiment } = options.filter((option) => option.value === props.data.value)[0]
		const renderColorOption = (colorOption: ColorOption) => {
			if (colorOption.sentiment === sentiment) {
				return (
					<div
						style={{ borderColor: colorOption.color }}
						className="h-[24px] w-[24px] flex border justify-center items-center rounded-md outline-offset-0"
					>
						{colorOption.sentiment === null ? (
							<i className="fa-light fa-empty-set text-gray-500"></i>
						) : (
							<div style={{ background: colorOption.color }} className="h-[16px] w-[16px] rounded-md"></div>
						)}
					</div>
				)
			}
			return colorOption.sentiment === null ? (
				<i className="fa-light fa-empty-set text-gray-500"></i>
			) : (
				<div style={{ background: colorOption.color }} className="h-[16px] w-[16px] rounded-md"></div>
			)
		}

		return (
			// @ts-ignore
			<Tippy
				interactive={true}
				theme={'tooltip-select'}
				popperOptions={{ strategy: 'fixed' }}
				arrow={false}
				trigger={'click'}
				content={
					<ul className="flex space-x-2 justify-center items-center">
						{colorOptions.map((colorOption) => (
							<li
								key={colorOption.sentiment}
								className="cursor-pointer"
								onClick={() =>
									handleSetSentiment(
										colorOption.sentiment === undefined ? null : colorOption.sentiment,
										props.data.value,
									)
								}
							>
								{renderColorOption(colorOption)}
							</li>
						))}
					</ul>
				}
			>
				<div>
					<components.MultiValueContainer {...props} />
				</div>
			</Tippy>
		)
	}

	return {
		MultiValueContainer,
	}
}

export default Tooltip
